import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreRegister } from '../SatCoreRegistry';

import BasicIframeModalLauncherService from '../services/BasicIframeModalLauncherService';

const FloatingHelpLauncher = observer((props = {}) => {
  const { dialogManager } = useContext(MobXProviderContext);
  const { headerTitle, iframeModalLauncherObj } = props;

  useEffect(() => {
    const launchFloatingHelp = async () => {
      const launchedFromAgentLink = await BasicIframeModalLauncherService.launchFloatingHelpFromAgentLinkIfApplicable(
        dialogManager,
        { headerTitle, iframeModalLauncherObj }
      );

      if (launchedFromAgentLink) {
        return;
      }

      if (!BasicIframeModalLauncherService.shouldAutoShowFloatingHelp(iframeModalLauncherObj)) {
        return;
      }

      const opened = await BasicIframeModalLauncherService.openIframeModalFromLauncher(
        dialogManager,
        iframeModalLauncherObj,
        { headerTitle }
      );

      if (opened) {
        BasicIframeModalLauncherService.markFloatingHelpAsShown(iframeModalLauncherObj);
      }
    };

    const timeout = setTimeout(() => {
      launchFloatingHelp();
    }, 500);

    return () => clearTimeout(timeout);
  }, [dialogManager, headerTitle, iframeModalLauncherObj]);

  return null;
});

export default FloatingHelpLauncher;

SatCoreRegister('FloatingHelpLauncher', FloatingHelpLauncher);
